const countries = [
  {
    name: 'Afghanistan',
    callingCodes: ['93'],
    flag: '/img/flags/af.svg',
    timezones: ['UTC+04:30'],
    island: false,
    vies: false,
    code: 'AF',
  },
  {
    name: 'Aland_Islands',
    callingCodes: ['358'],
    flag: '/img/flags/ax.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'AX',
  },
  {
    name: 'Albania',
    callingCodes: ['355'],
    flag: '/img/flags/al.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'AL',
  },
  {
    name: 'Algeria',
    callingCodes: ['213'],
    flag: '/img/flags/dz.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'DZ',
  },
  {
    name: 'American_Samoa',
    callingCodes: ['1684'],
    flag: '/img/flags/as.svg',
    timezones: ['UTC-11:00'],
    island: false,
    vies: false,
    code: 'AS',
  },
  {
    name: 'Andorra',
    callingCodes: ['376'],
    flag: '/img/flags/ad.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'AD',
  },
  {
    name: 'Angola',
    callingCodes: ['244'],
    flag: '/img/flags/ao.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'AO',
  },
  {
    name: 'Anguilla',
    callingCodes: ['1264'],
    flag: '/img/flags/ai.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'AI',
  },
  {
    name: 'Antarctica',
    callingCodes: ['672'],
    flag: '/img/flags/aq.svg',
    timezones: ['UTC-03:00', 'UTC+03:00', 'UTC+05:00', 'UTC+06:00', 'UTC+07:00', 'UTC+08:00', 'UTC+10:00', 'UTC+12:00'],
    island: false,
    vies: false,
    code: 'AQ',
  },
  {
    name: 'Antigua_and_Barbuda',
    callingCodes: ['1268'],
    flag: '/img/flags/ag.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'AG',
  },
  {
    name: 'Antilhas_Neerlandesas',
    callingCodes: ['599'],
    flag: '/img/flags/an.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'AN',
  },
  {
    name: 'Argentina',
    callingCodes: ['54'],
    flag: '/img/flags/ar.svg',
    timezones: ['UTC-03:00'],
    island: false,
    vies: false,
    code: 'AR',
  },
  {
    name: 'Armenia',
    callingCodes: ['374'],
    flag: '/img/flags/am.svg',
    timezones: ['UTC+04:00'],
    island: false,
    vies: false,
    code: 'AM',
  },
  {
    name: 'Aruba',
    callingCodes: ['297'],
    flag: '/img/flags/aw.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'AW',
  },
  {
    name: 'Australia',
    callingCodes: ['61'],
    flag: '/img/flags/au.svg',
    timezones: ['UTC+05:00', 'UTC+06:30', 'UTC+07:00', 'UTC+08:00', 'UTC+09:30', 'UTC+10:00', 'UTC+10:30', 'UTC+11:30'],
    island: false,
    vies: false,
    code: 'AU',
  },
  {
    name: 'Austria',
    callingCodes: ['43'],
    flag: '/img/flags/at.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    callingCodes: ['994'],
    flag: '/img/flags/az.svg',
    timezones: ['UTC+04:00'],
    island: false,
    vies: false,
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    callingCodes: ['1242'],
    flag: '/img/flags/bs.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'BS',
  },
  {
    name: 'Bahrain',
    callingCodes: ['973'],
    flag: '/img/flags/bh.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    callingCodes: ['880'],
    flag: '/img/flags/bd.svg',
    timezones: ['UTC+06:00'],
    island: false,
    vies: false,
    code: 'BD',
  },
  {
    name: 'Barbados',
    callingCodes: ['1246'],
    flag: '/img/flags/bb.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'BB',
  },
  {
    name: 'Belarus',
    callingCodes: ['375'],
    flag: '/img/flags/by.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'BY',
  },
  {
    name: 'Belgium',
    callingCodes: ['32'],
    flag: '/img/flags/be.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'BE',
  },
  {
    name: 'Belize',
    callingCodes: ['501'],
    flag: '/img/flags/bz.svg',
    timezones: ['UTC-06:00'],
    island: false,
    vies: false,
    code: 'BZ',
  },
  {
    name: 'Benin',
    callingCodes: ['229'],
    flag: '/img/flags/bj.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    callingCodes: ['1441'],
    flag: '/img/flags/bm.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'BM',
  },
  {
    name: 'Bhutan',
    callingCodes: ['975'],
    flag: '/img/flags/bt.svg',
    timezones: ['UTC+06:00'],
    island: false,
    vies: false,
    code: 'BT',
  },
  {
    name: 'Bolivia_(Plurinational_State_of)',
    callingCodes: ['591'],
    flag: '/img/flags/bo.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'BO',
  },
  // {
  //   name: 'Bonaire__Sint_Eustatius_and_Saba',
  //   callingCodes: ['5997'],
  //   flag: '/img/flags/be.svg',
  //   timezones: ['UTC-04:00'],
  //   island: false,
  //   vies: false,
  //   code: 'BE',
  // },
  {
    name: 'Bosnia_and_Herzegovina',
    callingCodes: ['387'],
    flag: '/img/flags/ba.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'BA',
  },
  {
    name: 'Botswana',
    callingCodes: ['267'],
    flag: '/img/flags/bw.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'BW',
  },
  {
    name: 'Bouvet_Island',
    callingCodes: [''],
    flag: '/img/flags/bv.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'BV',
  },
  {
    name: 'Brazil',
    callingCodes: ['55'],
    flag: '/img/flags/br.svg',
    timezones: ['UTC-05:00', 'UTC-04:00', 'UTC-03:00', 'UTC-02:00'],
    island: false,
    vies: false,
    code: 'BR',
  },
  {
    name: 'British_Indian_Ocean_Territory',
    callingCodes: ['246'],
    flag: '/img/flags/io.svg',
    timezones: ['UTC+06:00'],
    island: false,
    vies: false,
    code: 'IO',
  },
  {
    name: 'United_States_Minor_Outlying_Islands',
    callingCodes: [''],
    flag: '/img/flags/um.svg',
    timezones: ['UTC-11:00', 'UTC-10:00', 'UTC+12:00'],
    island: false,
    vies: false,
    code: 'UM',
  },
  {
    name: 'Virgin_Islands_(British)',
    callingCodes: ['1284'],
    flag: '/img/flags/vg.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'VG',
  },
  {
    name: 'Virgin_Islands_(US)',
    callingCodes: ['1340'],
    flag: '/img/flags/vi.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'VI',
  },
  {
    name: 'Brunei_Darussalam',
    callingCodes: ['673'],
    flag: '/img/flags/bn.svg',
    timezones: ['UTC+08:00'],
    island: false,
    vies: false,
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    callingCodes: ['359'],
    flag: '/img/flags/bg.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: true,
    code: 'BG',
  },
  {
    name: 'Burkina_Faso',
    callingCodes: ['226'],
    flag: '/img/flags/bf.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'BF',
  },
  {
    name: 'Burundi',
    callingCodes: ['257'],
    flag: '/img/flags/bi.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'BI',
  },
  {
    name: 'Cambodia',
    callingCodes: ['855'],
    flag: '/img/flags/kh.svg',
    timezones: ['UTC+07:00'],
    island: false,
    vies: false,
    code: 'KH',
  },
  {
    name: 'Cameroon',
    callingCodes: ['237'],
    flag: '/img/flags/cm.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'CM',
  },
  {
    name: 'Canada',
    callingCodes: ['1'],
    flag: '/img/flags/ca.svg',
    timezones: ['UTC-08:00', 'UTC-07:00', 'UTC-06:00', 'UTC-05:00', 'UTC-04:00', 'UTC-03:30'],
    island: false,
    vies: false,
    code: 'CA',
  },
  {
    name: 'Cabo_Verde',
    callingCodes: ['238'],
    flag: '/img/flags/cv.svg',
    timezones: ['UTC-01:00'],
    island: false,
    vies: false,
    code: 'CV',
  },
  {
    name: 'Cayman_Islands',
    callingCodes: ['1345'],
    flag: '/img/flags/ky.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'KY',
  },
  {
    name: 'Central_African_Republic',
    callingCodes: ['236'],
    flag: '/img/flags/cf.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'CF',
  },
  {
    name: 'Chad',
    callingCodes: ['235'],
    flag: '/img/flags/td.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'TD',
  },
  {
    name: 'Chile',
    callingCodes: ['56'],
    flag: '/img/flags/cl.svg',
    timezones: ['UTC-06:00', 'UTC-04:00'],
    island: false,
    vies: false,
    code: 'CL',
  },
  {
    name: 'China',
    callingCodes: ['86'],
    flag: '/img/flags/cn.svg',
    timezones: ['UTC+08:00'],
    island: false,
    vies: false,
    code: 'CN',
  },
  {
    name: 'Christmas_Island',
    callingCodes: ['61'],
    flag: '/img/flags/cx.svg',
    timezones: ['UTC+07:00'],
    island: false,
    vies: false,
    code: 'CX',
  },
  {
    name: 'Cocos_(Keeling)_Islands',
    callingCodes: ['61'],
    flag: '/img/flags/cc.svg',
    timezones: ['UTC+06:30'],
    island: false,
    vies: false,
    code: 'CC',
  },
  {
    name: 'Colombia',
    callingCodes: ['57'],
    flag: '/img/flags/co.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'CO',
  },
  {
    name: 'Comoros',
    callingCodes: ['269'],
    flag: '/img/flags/km.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'KM',
  },
  {
    name: 'Congo',
    callingCodes: ['242'],
    flag: '/img/flags/cg.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'CG',
  },
  {
    name: 'Congo_(Democratic_Republic_of_the)',
    callingCodes: ['243'],
    flag: '/img/flags/cd.svg',
    timezones: ['UTC+01:00', 'UTC+02:00'],
    island: false,
    vies: false,
    code: 'CD',
  },
  {
    name: 'Cook_Islands',
    callingCodes: ['682'],
    flag: '/img/flags/ck.svg',
    timezones: ['UTC-10:00'],
    island: false,
    vies: false,
    code: 'CK',
  },
  {
    name: 'Costa_Rica',
    callingCodes: ['506'],
    flag: '/img/flags/cr.svg',
    timezones: ['UTC-06:00'],
    island: false,
    vies: false,
    code: 'CR',
  },
  {
    name: 'Croatia',
    callingCodes: ['385'],
    flag: '/img/flags/hr.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'HR',
  },
  {
    name: 'Cuba',
    callingCodes: ['53'],
    flag: '/img/flags/cu.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'CU',
  },
  // {
  //   name: 'Curaçao',
  //   callingCodes: ['599'],
  //   flag: '/img/flags/cu.svg',
  //   timezones: ['UTC-04:00'],
  //   island: false,
  //   vies: false,
  //   code: 'CU',
  // },
  {
    name: 'Cyprus',
    callingCodes: ['357'],
    flag: '/img/flags/cy.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: true,
    code: 'CY',
  },
  {
    name: 'Czech_Republic',
    callingCodes: ['420'],
    flag: '/img/flags/cz.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'CZ',
  },
  {
    name: 'Denmark',
    callingCodes: ['45'],
    flag: '/img/flags/dk.svg',
    timezones: ['UTC-04:00', 'UTC-03:00', 'UTC-01:00', 'UTC', 'UTC+01:00'],
    island: false,
    vies: true,
    code: 'DK',
  },
  {
    name: 'Djibouti',
    callingCodes: ['253'],
    flag: '/img/flags/dj.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'DJ',
  },
  {
    name: 'Dominica',
    callingCodes: ['1767'],
    flag: '/img/flags/dm.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'DM',
  },
  {
    name: 'Dominican_Republic',
    callingCodes: ['1809', '1829', '1849'],
    flag: '/img/flags/do.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'DO',
  },
  {
    name: 'Ecuador',
    callingCodes: ['593'],
    flag: '/img/flags/ec.svg',
    timezones: ['UTC-06:00', 'UTC-05:00'],
    island: false,
    vies: false,
    code: 'EC',
  },
  {
    name: 'Egypt',
    callingCodes: ['20'],
    flag: '/img/flags/eg.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'EG',
  },
  {
    name: 'El_Salvador',
    callingCodes: ['503'],
    flag: '/img/flags/sv.svg',
    timezones: ['UTC-06:00'],
    island: false,
    vies: false,
    code: 'SV',
  },
  {
    name: 'Equatorial_Guinea',
    callingCodes: ['240'],
    flag: '/img/flags/gq.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    callingCodes: ['291'],
    flag: '/img/flags/er.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'ER',
  },
  {
    name: 'Estonia',
    callingCodes: ['372'],
    flag: '/img/flags/ee.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: true,
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    callingCodes: ['251'],
    flag: '/img/flags/et.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'ET',
  },
  {
    name: 'European_Union',
    callingCodes: [],
    flag: '/img/flags/eu.svg',
    timezones: [],
    island: false,
    vies: false,
    code: 'EU',
  },
  {
    name: 'Falkland_Islands_(Malvinas)',
    callingCodes: ['500'],
    flag: '/img/flags/fk.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'FK',
  },
  {
    name: 'Faroe_Islands',
    callingCodes: ['298'],
    flag: '/img/flags/fo.svg',
    timezones: ['UTC+00:00'],
    island: false,
    vies: false,
    code: 'FO',
  },
  {
    name: 'Fiji',
    callingCodes: ['679'],
    flag: '/img/flags/fj.svg',
    timezones: ['UTC+12:00'],
    island: false,
    vies: false,
    code: 'FJ',
  },
  {
    name: 'Finland',
    callingCodes: ['358'],
    flag: '/img/flags/fi.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: true,
    code: 'FI',
  },
  {
    name: 'France',
    callingCodes: ['33'],
    flag: '/img/flags/fr.svg',
    timezones: [
      'UTC-10:00',
      'UTC-09:30',
      'UTC-09:00',
      'UTC-08:00',
      'UTC-04:00',
      'UTC-03:00',
      'UTC+01:00',
      'UTC+03:00',
      'UTC+04:00',
      'UTC+05:00',
      'UTC+11:00',
      'UTC+12:00',
    ],
    island: false,
    vies: true,
    code: 'FR',
  },
  {
    name: 'French_Guiana',
    callingCodes: ['594'],
    flag: '/img/flags/gf.svg',
    timezones: ['UTC-03:00'],
    island: false,
    vies: false,
    code: 'GF',
  },
  {
    name: 'French_Polynesia',
    callingCodes: ['689'],
    flag: '/img/flags/pf.svg',
    timezones: ['UTC-10:00', 'UTC-09:30', 'UTC-09:00'],
    island: false,
    vies: false,
    code: 'PF',
  },
  {
    name: 'French_Southern_Territories',
    callingCodes: [''],
    flag: '/img/flags/tf.svg',
    timezones: ['UTC+05:00'],
    island: false,
    vies: false,
    code: 'TF',
  },
  {
    name: 'Gabon',
    callingCodes: ['241'],
    flag: '/img/flags/ga.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'GA',
  },
  {
    name: 'Gambia',
    callingCodes: ['220'],
    flag: '/img/flags/gm.svg',
    timezones: ['UTC+00:00'],
    island: false,
    vies: false,
    code: 'GM',
  },
  {
    name: 'Georgia',
    callingCodes: ['995'],
    flag: '/img/flags/ge.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'GE',
  },
  {
    name: 'Germany',
    callingCodes: ['49'],
    flag: '/img/flags/de.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'DE',
  },
  {
    name: 'Ghana',
    callingCodes: ['233'],
    flag: '/img/flags/gh.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    callingCodes: ['350'],
    flag: '/img/flags/gi.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'GI',
  },
  {
    name: 'Greece',
    callingCodes: ['30'],
    flag: '/img/flags/gr.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: true,
    code: 'GR',
  },
  {
    name: 'Greenland',
    callingCodes: ['299'],
    flag: '/img/flags/gl.svg',
    timezones: ['UTC-04:00', 'UTC-03:00', 'UTC-01:00', 'UTC+00:00'],
    island: false,
    vies: false,
    code: 'GL',
  },
  {
    name: 'Grenada',
    callingCodes: ['1473'],
    flag: '/img/flags/gd.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    callingCodes: ['590'],
    flag: '/img/flags/gp.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'GP',
  },
  {
    name: 'Guam',
    callingCodes: ['1671'],
    flag: '/img/flags/gu.svg',
    timezones: ['UTC+10:00'],
    island: false,
    vies: false,
    code: 'GU',
  },
  {
    name: 'Guatemala',
    callingCodes: ['502'],
    flag: '/img/flags/gt.svg',
    timezones: ['UTC-06:00'],
    island: false,
    vies: false,
    code: 'GT',
  },
  {
    name: 'Guernsey',
    callingCodes: ['44'],
    flag: '/img/flags/gg.svg',
    timezones: ['UTC+00:00'],
    island: false,
    vies: false,
    code: 'GG',
  },
  {
    name: 'Guinea',
    callingCodes: ['224'],
    flag: '/img/flags/gn.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'GN',
  },
  {
    name: 'Guinea_Bissau',
    callingCodes: ['245'],
    flag: '/img/flags/gw.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'GW',
  },
  {
    name: 'Guyana',
    callingCodes: ['592'],
    flag: '/img/flags/gy.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'GY',
  },
  {
    name: 'Haiti',
    callingCodes: ['509'],
    flag: '/img/flags/ht.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'HT',
  },
  {
    name: 'Heard_Island_and_McDonald_Islands',
    callingCodes: [''],
    flag: '/img/flags/hm.svg',
    timezones: ['UTC+05:00'],
    island: false,
    vies: false,
    code: 'HM',
  },
  {
    name: 'Holy_See',
    callingCodes: ['379'],
    flag: '/img/flags/va.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'VA',
  },
  {
    name: 'Honduras',
    callingCodes: ['504'],
    flag: '/img/flags/hn.svg',
    timezones: ['UTC-06:00'],
    island: false,
    vies: false,
    code: 'HN',
  },
  {
    name: 'Hong_Kong',
    callingCodes: ['852'],
    flag: '/img/flags/hk.svg',
    timezones: ['UTC+08:00'],
    island: false,
    vies: false,
    code: 'HK',
  },
  {
    name: 'Hungary',
    callingCodes: ['36'],
    flag: '/img/flags/hu.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'HU',
  },
  {
    name: 'Iceland',
    callingCodes: ['354'],
    flag: '/img/flags/is.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'IS',
  },
  {
    name: 'India',
    callingCodes: ['91'],
    flag: '/img/flags/in.svg',
    timezones: ['UTC+05:30'],
    island: false,
    vies: false,
    code: 'IN',
  },
  {
    name: 'Indonesia',
    callingCodes: ['62'],
    flag: '/img/flags/id.svg',
    timezones: ['UTC+07:00', 'UTC+08:00', 'UTC+09:00'],
    island: false,
    vies: false,
    code: 'ID',
  },
  {
    name: 'Cote_d_Ivoire',
    callingCodes: ['225'],
    flag: '/img/flags/ci.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'CI',
  },
  {
    name: 'Iran_(Islamic_Republic_of)',
    callingCodes: ['98'],
    flag: '/img/flags/ir.svg',
    timezones: ['UTC+03:30'],
    island: false,
    vies: false,
    code: 'IR',
  },
  {
    name: 'Iraq',
    callingCodes: ['964'],
    flag: '/img/flags/iq.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'IQ',
  },
  {
    name: 'Ireland',
    callingCodes: ['353'],
    flag: '/img/flags/ie.svg',
    timezones: ['UTC'],
    island: false,
    vies: true,
    code: 'IE',
  },
  {
    name: 'northern_ireland',
    callingCodes: [],
    flag: '/img/flags/ix.svg',
    timezones: ['UTC'],
    island: false,
    vies: true,
    code: 'IX',
  },
  {
    name: 'Isle_of_Man',
    callingCodes: ['44'],
    flag: '/img/flags/im.svg',
    timezones: ['UTC+00:00'],
    island: false,
    vies: false,
    code: 'IM',
  },
  {
    name: 'Israel',
    callingCodes: ['972'],
    flag: '/img/flags/il.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'IL',
  },
  {
    name: 'Italy',
    callingCodes: ['39'],
    flag: '/img/flags/it.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'IT',
  },
  {
    name: 'Jamaica',
    callingCodes: ['1876'],
    flag: '/img/flags/jm.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'JM',
  },
  {
    name: 'Japan',
    callingCodes: ['81'],
    flag: '/img/flags/jp.svg',
    timezones: ['UTC+09:00'],
    island: false,
    vies: false,
    code: 'JP',
  },
  {
    name: 'Jersey',
    callingCodes: ['44'],
    flag: '/img/flags/je.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'JE',
  },
  {
    name: 'Jordan',
    callingCodes: ['962'],
    flag: '/img/flags/jo.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    callingCodes: ['76', '77'],
    flag: '/img/flags/kz.svg',
    timezones: ['UTC+05:00', 'UTC+06:00'],
    island: false,
    vies: false,
    code: 'KZ',
  },
  {
    name: 'Kenya',
    callingCodes: ['254'],
    flag: '/img/flags/ke.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'KE',
  },
  {
    name: 'Kiribati',
    callingCodes: ['686'],
    flag: '/img/flags/ki.svg',
    timezones: ['UTC+12:00', 'UTC+13:00', 'UTC+14:00'],
    island: false,
    vies: false,
    code: 'KI',
  },
  {
    name: 'Kuwait',
    callingCodes: ['965'],
    flag: '/img/flags/kw.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    callingCodes: ['996'],
    flag: '/img/flags/kg.svg',
    timezones: ['UTC+06:00'],
    island: false,
    vies: false,
    code: 'KG',
  },
  {
    name: 'Lao_Peoples_Democratic_Republic',
    callingCodes: ['856'],
    flag: '/img/flags/la.svg',
    timezones: ['UTC+07:00'],
    island: false,
    vies: false,
    code: 'LA',
  },
  {
    name: 'Latvia',
    callingCodes: ['371'],
    flag: '/img/flags/lv.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: true,
    code: 'LV',
  },
  {
    name: 'Lebanon',
    callingCodes: ['961'],
    flag: '/img/flags/lb.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'LB',
  },
  {
    name: 'Lesotho',
    callingCodes: ['266'],
    flag: '/img/flags/ls.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'LS',
  },
  {
    name: 'Liberia',
    callingCodes: ['231'],
    flag: '/img/flags/lr.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'LR',
  },
  {
    name: 'Libya',
    callingCodes: ['218'],
    flag: '/img/flags/ly.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    callingCodes: ['423'],
    flag: '/img/flags/li.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'LI',
  },
  {
    name: 'Lithuania',
    callingCodes: ['370'],
    flag: '/img/flags/lt.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: true,
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    callingCodes: ['352'],
    flag: '/img/flags/lu.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'LU',
  },
  {
    name: 'Macao',
    callingCodes: ['853'],
    flag: '/img/flags/mo.svg',
    timezones: ['UTC+08:00'],
    island: false,
    vies: false,
    code: 'MO',
  },
  {
    name: 'Macedonia_(the_former_Yugoslav_Republic_of)',
    callingCodes: ['389'],
    flag: '/img/flags/mk.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'MK',
  },
  {
    name: 'Madagascar',
    callingCodes: ['261'],
    flag: '/img/flags/mg.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'MG',
  },
  {
    name: 'Malawi',
    callingCodes: ['265'],
    flag: '/img/flags/mw.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'MW',
  },
  {
    name: 'Malaysia',
    callingCodes: ['60'],
    flag: '/img/flags/my.svg',
    timezones: ['UTC+08:00'],
    island: false,
    vies: false,
    code: 'MY',
  },
  {
    name: 'Maldives',
    callingCodes: ['960'],
    flag: '/img/flags/mv.svg',
    timezones: ['UTC+05:00'],
    island: false,
    vies: false,
    code: 'MV',
  },
  {
    name: 'Mali',
    callingCodes: ['223'],
    flag: '/img/flags/ml.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'ML',
  },
  {
    name: 'Malta',
    callingCodes: ['356'],
    flag: '/img/flags/mt.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'MT',
  },
  {
    name: 'Marshall_Islands',
    callingCodes: ['692'],
    flag: '/img/flags/mh.svg',
    timezones: ['UTC+12:00'],
    island: false,
    vies: false,
    code: 'MH',
  },
  {
    name: 'Martinique',
    callingCodes: ['596'],
    flag: '/img/flags/mq.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    callingCodes: ['222'],
    flag: '/img/flags/mr.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'MR',
  },
  {
    name: 'Mauritius',
    callingCodes: ['230'],
    flag: '/img/flags/mu.svg',
    timezones: ['UTC+04:00'],
    island: false,
    vies: false,
    code: 'MU',
  },
  {
    name: 'Mayotte',
    callingCodes: ['262'],
    flag: '/img/flags/yt.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'YT',
  },
  {
    name: 'Mexico',
    callingCodes: ['52'],
    flag: '/img/flags/mx.svg',
    timezones: ['UTC-08:00', 'UTC-07:00', 'UTC-06:00'],
    island: false,
    vies: false,
    code: 'MX',
  },
  {
    name: 'Micronesia_(Federated_States_of)',
    callingCodes: ['691'],
    flag: '/img/flags/fm.svg',
    timezones: ['UTC+10:00', 'UTC+11'],
    island: false,
    vies: false,
    code: 'FM',
  },
  {
    name: 'Moldova_(Republic_of)',
    callingCodes: ['373'],
    flag: '/img/flags/md.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'MD',
  },
  {
    name: 'Monaco',
    callingCodes: ['377'],
    flag: '/img/flags/mc.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'MC',
  },
  {
    name: 'Mongolia',
    callingCodes: ['976'],
    flag: '/img/flags/mn.svg',
    timezones: ['UTC+07:00', 'UTC+08:00'],
    island: false,
    vies: false,
    code: 'MN',
  },
  {
    name: 'Montenegro',
    callingCodes: ['382'],
    flag: '/img/flags/me.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'ME',
  },
  {
    name: 'Montserrat',
    callingCodes: ['1664'],
    flag: '/img/flags/ms.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'MS',
  },
  {
    name: 'Morocco',
    callingCodes: ['212'],
    flag: '/img/flags/ma.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'MA',
  },
  {
    name: 'Mozambique',
    callingCodes: ['258'],
    flag: '/img/flags/mz.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'MZ',
  },
  {
    name: 'Myanmar',
    callingCodes: ['95'],
    flag: '/img/flags/mm.svg',
    timezones: ['UTC+06:30'],
    island: false,
    vies: false,
    code: 'MM',
  },
  {
    name: 'Namibia',
    callingCodes: ['264'],
    flag: '/img/flags/na.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'NA',
  },
  {
    name: 'Nauru',
    callingCodes: ['674'],
    flag: '/img/flags/nr.svg',
    timezones: ['UTC+12:00'],
    island: false,
    vies: false,
    code: 'NR',
  },
  {
    name: 'Nepal',
    callingCodes: ['977'],
    flag: '/img/flags/np.svg',
    timezones: ['UTC+05:45'],
    island: false,
    vies: false,
    code: 'NP',
  },
  {
    name: 'Netherlands',
    callingCodes: ['31'],
    flag: '/img/flags/nl.svg',
    timezones: ['UTC-04:00', 'UTC+01:00'],
    island: false,
    vies: true,
    code: 'NL',
  },
  {
    name: 'New_Caledonia',
    callingCodes: ['687'],
    flag: '/img/flags/nc.svg',
    timezones: ['UTC+11:00'],
    island: false,
    vies: false,
    code: 'NC',
  },
  {
    name: 'New_Zealand',
    callingCodes: ['64'],
    flag: '/img/flags/nz.svg',
    timezones: ['UTC-11:00', 'UTC-10:00', 'UTC+12:00', 'UTC+12:45', 'UTC+13:00'],
    island: false,
    vies: false,
    code: 'NZ',
  },
  {
    name: 'Nicaragua',
    callingCodes: ['505'],
    flag: '/img/flags/ni.svg',
    timezones: ['UTC-06:00'],
    island: false,
    vies: false,
    code: 'NI',
  },
  {
    name: 'Niger',
    callingCodes: ['227'],
    flag: '/img/flags/ng.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'NE',
  },
  {
    name: 'Nigeria',
    callingCodes: ['234'],
    flag: '/img/flags/ng.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'NG',
  },
  {
    name: 'Niue',
    callingCodes: ['683'],
    flag: '/img/flags/ni.svg',
    timezones: ['UTC-11:00'],
    island: false,
    vies: false,
    code: 'NU',
  },
  {
    name: 'Norfolk_Island',
    callingCodes: ['672'],
    flag: '/img/flags/nf.svg',
    timezones: ['UTC+11:30'],
    island: false,
    vies: false,
    code: 'NF',
  },
  {
    name: 'Korea_(Democratic_Peoples_Republic_of)',
    callingCodes: ['850'],
    flag: '/img/flags/kp.svg',
    timezones: ['UTC+09:00'],
    island: false,
    vies: false,
    code: 'KP',
  },
  {
    name: 'Northern_Mariana_Islands',
    callingCodes: ['1670'],
    flag: '/img/flags/mp.svg',
    timezones: ['UTC+10:00'],
    island: false,
    vies: false,
    code: 'MP',
  },
  {
    name: 'Norway',
    callingCodes: ['47'],
    flag: '/img/flags/no.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'NO',
  },
  {
    name: 'Oman',
    callingCodes: ['968'],
    flag: '/img/flags/om.svg',
    timezones: ['UTC+04:00'],
    island: false,
    vies: false,
    code: 'OM',
  },
  {
    name: 'Pakistan',
    callingCodes: ['92'],
    flag: '/img/flags/pk.svg',
    timezones: ['UTC+05:00'],
    island: false,
    vies: false,
    code: 'PK',
  },
  {
    name: 'Palau',
    callingCodes: ['680'],
    flag: '/img/flags/pw.svg',
    timezones: ['UTC+09:00'],
    island: false,
    vies: false,
    code: 'PW',
  },
  {
    name: 'Palestine__State_of',
    callingCodes: ['970'],
    flag: '/img/flags/ps.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'PS',
  },
  {
    name: 'Panama',
    callingCodes: ['507'],
    flag: '/img/flags/pa.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'PA',
  },
  {
    name: 'Papua_New_Guinea',
    callingCodes: ['675'],
    flag: '/img/flags/pg.svg',
    timezones: ['UTC+10:00'],
    island: false,
    vies: false,
    code: 'PG',
  },
  {
    name: 'Paraguay',
    callingCodes: ['595'],
    flag: '/img/flags/py.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'PY',
  },
  {
    name: 'Peru',
    callingCodes: ['51'],
    flag: '/img/flags/pe.svg',
    timezones: ['UTC-05:00'],
    island: false,
    vies: false,
    code: 'PE',
  },
  {
    name: 'Philippines',
    callingCodes: ['63'],
    flag: '/img/flags/ph.svg',
    timezones: ['UTC+08:00'],
    island: false,
    vies: false,
    code: 'PH',
  },
  {
    name: 'Pitcairn',
    callingCodes: ['64'],
    flag: '/img/flags/pn.svg',
    timezones: ['UTC-08:00'],
    island: false,
    vies: false,
    code: 'PN',
  },
  {
    name: 'Poland',
    callingCodes: ['48'],
    flag: '/img/flags/pl.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'PL',
  },
  {
    name: 'Portugal',
    callingCodes: ['351'],
    flag: '/img/flags/pt.svg',
    timezones: ['UTC-01:00', 'UTC'],
    island: false,
    vies: false,
    code: 'PT',
  },
  {
    name: 'Puerto_Rico',
    callingCodes: ['1787', '1939'],
    flag: '/img/flags/pr.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'PR',
  },
  {
    name: 'Qatar',
    callingCodes: ['974'],
    flag: '/img/flags/qa.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'QA',
  },
  {
    name: 'Republic_of_Kosovo',
    callingCodes: ['383'],
    flag: '/img/flags/xk.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'XK',
  },
  {
    name: 'Réunion',
    callingCodes: ['262'],
    flag: '/img/flags/re.svg',
    timezones: ['UTC+04:00'],
    island: false,
    vies: false,
    code: 'RE',
  },
  {
    name: 'Romania',
    callingCodes: ['40'],
    flag: '/img/flags/ro.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: true,
    code: 'RO',
  },
  {
    name: 'Russian_Federation',
    callingCodes: ['7'],
    flag: '/img/flags/ru.svg',
    timezones: ['UTC+03:00', 'UTC+04:00', 'UTC+06:00', 'UTC+07:00', 'UTC+08:00', 'UTC+09:00', 'UTC+10:00', 'UTC+11:00', 'UTC+12:00'],
    island: false,
    vies: false,
    code: 'RU',
  },
  {
    name: 'Rwanda',
    callingCodes: ['250'],
    flag: '/img/flags/rw.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'RW',
  },
  {
    name: 'Saint_Barthélemy',
    callingCodes: ['590'],
    flag: '/img/flags/bl.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'BL',
  },
  {
    name: 'Saint_Helena,_Ascension_and_Tristan_da_Cunha',
    callingCodes: ['290'],
    flag: '/img/flags/sh.svg',
    timezones: ['UTC+00:00'],
    island: false,
    vies: false,
    code: 'SH',
  },
  {
    name: 'Saint_Kitts_and_Nevis',
    callingCodes: ['1869'],
    flag: '/img/flags/kn.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'KN',
  },
  {
    name: 'Saint_Lucia',
    callingCodes: ['1758'],
    flag: '/img/flags/lc.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'LC',
  },
  {
    name: 'Saint_Martin_(French_part)',
    callingCodes: ['590'],
    flag: '/img/flags/mf.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'MF',
  },
  {
    name: 'Saint_Pierre_and_Miquelon',
    callingCodes: ['508'],
    flag: '/img/flags/pm.svg',
    timezones: ['UTC-03:00'],
    island: false,
    vies: false,
    code: 'PM',
  },
  {
    name: 'Saint_Vincent_and_the_Grenadines',
    callingCodes: ['1784'],
    flag: '/img/flags/vc.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'VC',
  },
  {
    name: 'Samoa',
    callingCodes: ['685'],
    flag: '/img/flags/ws.svg',
    timezones: ['UTC+13:00'],
    island: false,
    vies: false,
    code: 'WS',
  },
  {
    name: 'San_Marino',
    callingCodes: ['378'],
    flag: '/img/flags/sm.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'SM',
  },
  {
    name: 'Sao_Tome_and_Principe',
    callingCodes: ['239'],
    flag: '/img/flags/st.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'ST',
  },
  {
    name: 'Saudi_Arabia',
    callingCodes: ['966'],
    flag: '/img/flags/sa.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'SA',
  },
  {
    name: 'Senegal',
    callingCodes: ['221'],
    flag: '/img/flags/sn.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'SN',
  },
  {
    name: 'Serbia',
    callingCodes: ['381'],
    flag: '/img/flags/rs.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'RS',
  },
  {
    name: 'Seychelles',
    callingCodes: ['248'],
    flag: '/img/flags/sc.svg',
    timezones: ['UTC+04:00'],
    island: false,
    vies: false,
    code: 'SC',
  },
  {
    name: 'Sierra_Leone',
    callingCodes: ['232'],
    flag: '/img/flags/sl.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'SL',
  },
  {
    name: 'Singapore',
    callingCodes: ['65'],
    flag: '/img/flags/sg.svg',
    timezones: ['UTC+08:00'],
    island: false,
    vies: false,
    code: 'SG',
  },
  {
    name: 'Sint_Maarten_(Dutch_part)',
    callingCodes: ['1721'],
    flag: '/img/flags/sx.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'SX',
  },
  {
    name: 'Slovakia',
    callingCodes: ['421'],
    flag: '/img/flags/sk.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'SK',
  },
  {
    name: 'Slovenia',
    callingCodes: ['386'],
    flag: '/img/flags/si.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'SI',
  },
  {
    name: 'Solomon_Islands',
    callingCodes: ['677'],
    flag: '/img/flags/sb.svg',
    timezones: ['UTC+11:00'],
    island: false,
    vies: false,
    code: 'SB',
  },
  {
    name: 'Somalia',
    callingCodes: ['252'],
    flag: '/img/flags/so.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'SO',
  },
  {
    name: 'South_Africa',
    callingCodes: ['27'],
    flag: '/img/flags/za.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'ZA',
  },
  {
    name: 'South_Georgia_and_the_South_Sandwich_Islands',
    callingCodes: ['500'],
    flag: '/img/flags/gs.svg',
    timezones: ['UTC-02:00'],
    island: false,
    vies: false,
    code: 'GS',
  },
  {
    name: 'Korea_(Republic_of)',
    callingCodes: ['82'],
    flag: '/img/flags/kr.svg',
    timezones: ['UTC+09:00'],
    island: false,
    vies: false,
    code: 'KR',
  },
  {
    name: 'Rest_of_world',
    callingCodes: [''],
    flag: '/img/flags/row.svg',
    timezones: [''],
    island: false,
    vies: false,
    code: 'RoW',
  },
  {
    name: 'South_Sudan',
    callingCodes: ['211'],
    flag: '/img/flags/ss.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'SS',
  },
  {
    name: 'Spain',
    callingCodes: ['34'],
    flag: '/img/flags/es.svg',
    timezones: ['UTC', 'UTC+01:00'],
    island: false,
    vies: true,
    code: 'ES',
  },
  {
    name: 'Sri_Lanka',
    callingCodes: ['94'],
    flag: '/img/flags/lk.svg',
    timezones: ['UTC+05:30'],
    island: false,
    vies: false,
    code: 'LK',
  },
  {
    name: 'Sudan',
    callingCodes: ['249'],
    flag: '/img/flags/sd.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'SD',
  },
  {
    name: 'Suriname',
    callingCodes: ['597'],
    flag: '/img/flags/sr.svg',
    timezones: ['UTC-03:00'],
    island: false,
    vies: false,
    code: 'SR',
  },
  {
    name: 'Svalbard_and_Jan_Mayen',
    callingCodes: ['4779'],
    flag: '/img/flags/sj.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    callingCodes: ['268'],
    flag: '/img/flags/sz.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'SZ',
  },
  {
    name: 'Sweden',
    callingCodes: ['46'],
    flag: '/img/flags/se.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: true,
    code: 'SE',
  },
  {
    name: 'Switzerland',
    callingCodes: ['41'],
    flag: '/img/flags/ch.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'CH',
  },
  {
    name: 'Syrian_Arab_Republic',
    callingCodes: ['963'],
    flag: '/img/flags/sy.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'SY',
  },
  {
    name: 'Taiwan',
    callingCodes: ['886'],
    flag: '/img/flags/tw.svg',
    timezones: ['UTC+08:00'],
    island: false,
    vies: false,
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    callingCodes: ['992'],
    flag: '/img/flags/tj.svg',
    timezones: ['UTC+05:00'],
    island: false,
    vies: false,
    code: 'TJ',
  },
  {
    name: 'Tanzania__United_Republic_of',
    callingCodes: ['255'],
    flag: '/img/flags/tz.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'TZ',
  },
  {
    name: 'Thailand',
    callingCodes: ['66'],
    flag: '/img/flags/th.svg',
    timezones: ['UTC+07:00'],
    island: false,
    vies: false,
    code: 'TH',
  },
  {
    name: 'Timor_Leste',
    callingCodes: ['670'],
    flag: '/img/flags/tl.svg',
    timezones: ['UTC+09:00'],
    island: false,
    vies: false,
    code: 'TL',
  },
  {
    name: 'Togo',
    callingCodes: ['228'],
    flag: '/img/flags/tg.svg',
    timezones: ['UTC'],
    island: false,
    vies: false,
    code: 'TG',
  },
  {
    name: 'Tokelau',
    callingCodes: ['690'],
    flag: '/img/flags/tk.svg',
    timezones: ['UTC+13:00'],
    island: false,
    vies: false,
    code: 'TK',
  },
  {
    name: 'Tonga',
    callingCodes: ['676'],
    flag: '/img/flags/to.svg',
    timezones: ['UTC+13:00'],
    island: false,
    vies: false,
    code: 'TO',
  },
  {
    name: 'Trinidad_and_Tobago',
    callingCodes: ['1868'],
    flag: '/img/flags/tt.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'TT',
  },
  {
    name: 'Tunisia',
    callingCodes: ['216'],
    flag: '/img/flags/tn.svg',
    timezones: ['UTC+01:00'],
    island: false,
    vies: false,
    code: 'TN',
  },
  {
    name: 'Turkey',
    callingCodes: ['90'],
    flag: '/img/flags/tr.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    callingCodes: ['993'],
    flag: '/img/flags/tm.svg',
    timezones: ['UTC+05:00'],
    island: false,
    vies: false,
    code: 'TM',
  },
  {
    name: 'Turks_and_Caicos_Islands',
    callingCodes: ['1649'],
    flag: '/img/flags/tc.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    callingCodes: ['688'],
    flag: '/img/flags/tv.svg',
    timezones: ['UTC+12:00'],
    island: false,
    vies: false,
    code: 'TV',
  },
  {
    name: 'Uganda',
    callingCodes: ['256'],
    flag: '/img/flags/ug.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'UG',
  },
  {
    name: 'Ukraine',
    callingCodes: ['380'],
    flag: '/img/flags/ua.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'UA',
  },
  {
    name: 'United_Arab_Emirates',
    callingCodes: ['971'],
    flag: '/img/flags/ae.svg',
    timezones: ['UTC+04'],
    island: false,
    vies: false,
    code: 'AE',
  },
  {
    name: 'United_Kingdom_of_Great_Britain_and_Northern_Ireland',
    callingCodes: ['44'],
    flag: '/img/flags/gb.svg',
    timezones: ['UTC-08:00', 'UTC-05:00', 'UTC-04:00', 'UTC-03:00', 'UTC-02:00', 'UTC', 'UTC+01:00', 'UTC+02:00', 'UTC+06:00'],
    island: false,
    vies: false,
    code: 'GB',
  },
  {
    name: 'United_States_of_America',
    callingCodes: ['1'],
    flag: '/img/flags/us.svg',
    timezones: [
      'UTC-12:00',
      'UTC-11:00',
      'UTC-10:00',
      'UTC-09:00',
      'UTC-08:00',
      'UTC-07:00',
      'UTC-06:00',
      'UTC-05:00',
      'UTC-04:00',
      'UTC+10:00',
      'UTC+12:00',
    ],
    island: false,
    vies: false,
    code: 'US',
  },
  {
    name: 'Uruguay',
    callingCodes: ['598'],
    flag: '/img/flags/uy.svg',
    timezones: ['UTC-03:00'],
    island: false,
    vies: false,
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    callingCodes: ['998'],
    flag: '/img/flags/uz.svg',
    timezones: ['UTC+05:00'],
    island: false,
    vies: false,
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    callingCodes: ['678'],
    flag: '/img/flags/vu.svg',
    timezones: ['UTC+11:00'],
    island: false,
    vies: false,
    code: 'VU',
  },
  {
    name: 'Venezuela_(Bolivarian_Republic_of)',
    callingCodes: ['58'],
    flag: '/img/flags/ve.svg',
    timezones: ['UTC-04:00'],
    island: false,
    vies: false,
    code: 'VE',
  },
  {
    name: 'Viet_Nam',
    callingCodes: ['84'],
    flag: '/img/flags/vn.svg',
    timezones: ['UTC+07:00'],
    island: false,
    vies: false,
    code: 'VN',
  },
  {
    name: 'Wallis_and_Futuna',
    callingCodes: ['681'],
    flag: '/img/flags/wf.svg',
    timezones: ['UTC+12:00'],
    island: false,
    vies: false,
    code: 'WF',
  },
  {
    name: 'Western_Sahara',
    callingCodes: ['212'],
    flag: '/img/flags/eh.svg',
    timezones: ['UTC+00:00'],
    island: false,
    vies: false,
    code: 'EH',
  },
  {
    name: 'Yemen',
    callingCodes: ['967'],
    flag: '/img/flags/ye.svg',
    timezones: ['UTC+03:00'],
    island: false,
    vies: false,
    code: 'YE',
  },
  {
    name: 'Zambia',
    callingCodes: ['260'],
    flag: '/img/flags/zm.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    callingCodes: ['263'],
    flag: '/img/flags/zw.svg',
    timezones: ['UTC+02:00'],
    island: false,
    vies: false,
    code: 'ZW',
  },
]
export default countries
